import React from 'react';
import styles from './ErrorInput.module.css';
import VectorError from '../../assets/images/Vector.png';
import { useTranslation } from 'react-i18next';

interface ErrorMessageInput {
  messageHeader: string;
  errorMessage: string;
  remainingAttempts: string;
}

const ErrorInput = ({ messageHeader, errorMessage, remainingAttempts }: ErrorMessageInput) => {
  const { t } = useTranslation();
  return (
    <div className={styles.errorInput} data-testid="errorInputDiv" role={'alert'}>
      <div className={styles.errorMessageHeader}>
        <img className={styles.vectorImg} src={VectorError} alt={'errorInput'} />
        <h2>
          <span className={styles.messageHeader}>{t(`${messageHeader}`)}</span>
        </h2>
      </div>
      <span className={styles.errorMessage} data-testid="errorMessage">
        {t(`${errorMessage}.part1`)}

        {remainingAttempts !== '' ? (
          <>
            {` `}
            {t(`${errorMessage}.part2`, { num: remainingAttempts })}
          </>
        ) : (
          <></>
        )}
        <b> {t(`${errorMessage}.part3`)}</b>
        {` `}
        {t(`${errorMessage}.part4`)}
      </span>
    </div>
  );
};

export default ErrorInput;
